import React, { Component } from "react";
import moment from "moment";
import { AkProfilecard } from "@atlaskit/profilecard";

import "./profilePreviewCard.css";
export default class ProfilePreviewCard extends Component {
  render() {
    const data = this.props.data || {};
    const actions = this.props.actions || [];
    return (
      <div className="profile-card-container">
        <AkProfilecard
          location={data.location}
          presence={data.presence}
          presenceMessage={data.presenceMessage}
          style={{ maxWidth: "100%" }}
          fullName={data.displayName}
          meta={data.phoneNumber}
          nickname={data.twitter || data.facebook || data.linkedIn}
          email={data.email}
          className="listing-preview-card"
          avatarUrl={data.photoURL}
          timestring={
            data.created ? moment(data.created.toDate()).format("MMM Do") : ""
          }
          actions={
            actions
              ? actions.map(i => ({
                  label: i.label,
                  id: i.id,
                  callback: i.callback
                }))
              : null
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProfilePreviewCard/ProfilePreviewCard.js